export default {
  learningExperiencesTitle: 'Experiencias de aprendizaje: {code} - {name}',
  learningExperiencesPrintTitle: 'Experiencias de aprendizaje - {code} {name}',
  learningExperience: 'Experiencia de aprendizaje',
  summativeAndFormativeActivitiesAndEvaluations: 'Actividades y evaluaciones sumativas y formativas',
  numberAndNameEA: 'N° y NOMBRE EA',
  learningOutcomes: 'Resultado(s) de aprendizaje',
  descriptionHeader: 'DESCRIPCIÓN (Propósito, metodología, evaluaciones, ambientes, tiempos y recursos)',
  numberAndNameDirectedTeachingActivity: 'N° y NOMBRE ACTIVIDAD DOCENCIA DIRIGIDA',
  briefDescriptionForTeacher: 'Descripción breve DIRIGIDO AL DOCENTE',
  briefDescriptionForStudent: 'Descripción breve DIRIGIDO AL ESTUDIANTE',
  connectionWithEnvironment: 'Vinculación con el medio',
  achievementIndicators: 'Indicador(es) de logro',
  directedTeachingHours: 'Tiempo horas docencia dirigida',
  pedagogicalHours: 'Horas pedagógicas',
  autonomousWorkActivity: 'Actividad de trabajo autónomo del/la estudiante',
  autonomousWorkHours: 'Tiempo horas trabajo autónomo',
  chronologicalHours: 'Horas cronológicas',
  learningResources: 'Recursos de aprendizaje',
  learningResourcesSubtitle: '(PPT Interactiva, Videos, Tutoriales, Links, Podcast, etc)',
  learningResourcesSubtitle2: '(Guías, Instrucciones, Pautas de Evaluación)',
  educationalTechnology: 'Tecnología educativa',
  educationalTechnologySubtitle: 'Kaltura, C1DO1, Software, Aplicaciones Web (MIRO, Mentimeter, Jamboard)',
  mandatoryBibliography: 'Bibliografía obligatoria',
  mandatoryBibliographySubtitle: 'Incluir n°capítulos, y n°páginas.',
  supplementaryBibliography: 'Bibliografía complementaria',
  learningEnvironments: 'Ambientes de aprendizaje',
  numberOfStudents: 'Nº estudiantes',
  downloadXLS: 'Descargar XLS',
  eaPrefix: 'EA',
  raPrefix: 'RA',
  transversalExam: 'Examen Transversal',
  noLearningExperiencesRecord: 'No hay registro de experiencias de aprendizaje para esta {entity}.',
}
